import { Navigate } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import { EncryptStorage } from "encrypt-storage";

const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
const userInfo = encryptStorage.getItem("___info");

function UnprotectedRoutes({ children }) {
  const token = userInfo?.token;

  // Jika user sudah login dan ada token, redirect ke dashboard
  if (token) {
    return <Navigate to={ROUTES.dashboard} />;
  }

  // Jika belum login, tampilkan halaman (misal: login, register)
  return children;
}

export default UnprotectedRoutes;
